export const BUILDER_TYPE = 'builderType';


export const setBuilderType = (payload) => ({
    type: BUILDER_TYPE,
    payload
});
